import { render, staticRenderFns } from "./FxDex.vue?vue&type=template&id=167e8595&scoped=true"
import script from "./FxDex.vue?vue&type=script&lang=js"
export * from "./FxDex.vue?vue&type=script&lang=js"
import style0 from "./FxDex.vue?vue&type=style&index=0&id=167e8595&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "167e8595",
  null
  
)

export default component.exports